import classnames from 'classnames';
import { useState, type FunctionComponent } from 'react';
import { Modal } from '@/core/tamagoshi/Modal/Modal';
import { ModalContent } from '@/core/tamagoshi/Modal/ModalContent';
import { ModalHeader } from '@/core/tamagoshi/Modal/ModalHeader';
import { Text } from '@/core/tamagoshi/Text/Text';
import { Image } from '@/domains/core/Image/Image';
import { translate } from '@/domains/core/localization/translate';
import { Link } from '@/domains/core/routing/components/Link';
import { trackEnergyLabelClick } from '@/domains/productDiscovery/ProductPage/common/components/AddToCart/IndexLabels/tracking';
import { useScaledEnergyLabels } from '@/domains/productDiscovery/ProductPage/common/components/AddToCart/IndexLabels/useEnergy';
import { useDetail } from '@/domains/productDiscovery/ProductPage/hooks/useDetail';
import type { Attribute, Energy } from '@/domains/productDiscovery/ProductPage/interfaces/Detail.common.model';
import { EuEnergyLabel } from './EuEnergyLabel';
import styles from './labels.module.scss';
export interface EnergyContainerProps {
  attributes?: Attribute[];
  energy?: Energy;
}
const {
  energyLabelHeader
} = translate({
  "energyLabelHeader": "Energy Label"
});
export const EnergyLabel: FunctionComponent<EnergyContainerProps> = ({
  attributes,
  energy
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const {
    infoDocs
  } = useDetail();
  const {
    url: productInformationPdfUrl
  } = infoDocs?.find(doc => doc.key === 'productInformationPdf') || {};
  const scaledEnergyLabels = useScaledEnergyLabels(attributes);
  if (!scaledEnergyLabels) {
    return null;
  }
  const onLabelClick = () => {
    if (energy) {
      trackEnergyLabelClick(scaledEnergyLabels.energyAttribute.value);
      setIsModalOpen(true);
    }
  };
  const {
    energyLabels,
    energyAttribute,
    isEuEnergyLabel
  } = scaledEnergyLabels;
  const {
    productInformationSheet
  } = translate({
    "productInformationSheet": "Product Information Sheet"
  });
  return <>
      <div className="flex items-center gap-xs">
        {isEuEnergyLabel ? <EuEnergyLabel label={energyAttribute.value} onClick={onLabelClick} className={classnames(styles.euEnergyLabel, {
        [styles.clickable]: energy
      })} data-testid="euEnergyLabel" /> : <button type="button" className={classnames(styles.energyLabel, styles[energyLabels[energyAttribute.value] || 'default'], {
        [styles.clickable]: energy
      })} onClick={onLabelClick}>
            {energyAttribute.value}
          </button>}
        {productInformationPdfUrl && <Link href={productInformationPdfUrl} className={styles.productInfoSheet} target="_blank">
            {productInformationSheet}
          </Link>}
      </div>
      {isModalOpen && <Modal onClose={() => setIsModalOpen(false)}>
          <ModalHeader>
            <Text type="h4" weight="bold">
              {energyLabelHeader}
            </Text>
          </ModalHeader>
          <ModalContent className={styles.modalBody}>
            <Image src={energy?.imageUrl} alt="energy" loading="lazy" className={styles.img} width={undefined} height={undefined} />
          </ModalContent>
        </Modal>}
    </>;
};